import React from 'react';
import JobPositionDescriptionForm from './components/JobPositionDescriptionForm';

export default function JobPositionDescription({
	jobPosition,
	onSuccess,
	forceEditingMode = false
}) {
	return (
		<div className="job-position-description">
			<JobPositionDescriptionForm
				data={jobPosition}
				onSuccess={onSuccess}
				forceEditingMode={forceEditingMode}
			/>
		</div>
	);
}
